// Minimaler Parser für das Roborock-V1-Map-Format.
// Format-Referenz: PrototypeJa/Hypfer Valetudo + dustcloud rrmapparser.
// Magic "rr", 20-Byte Header, danach Block-Liste.
// Block-Header: type(u16) | header_len(u16) | data_len(u32) | type-spezifisch.

const TYPE_CHARGER = 1
const TYPE_IMAGE = 2
const TYPE_PATH = 3
const TYPE_ROBOT = 8

export function parseRoborockMap(buffer) {
  const dv = new DataView(buffer)
  if (dv.getUint8(0) !== 0x72 || dv.getUint8(1) !== 0x72) {
    throw new Error('Kein gültiges Roborock-Map (Magic "rr" fehlt)')
  }
  const result = { image: null, charger: null, robot: null, path: null }
  let offset = dv.getUint16(2, true) // top-level header length, üblich 20

  while (offset + 8 <= buffer.byteLength) {
    const type = dv.getUint16(offset, true)
    const headerLen = dv.getUint16(offset + 2, true)
    const dataLen = dv.getUint32(offset + 4, true)
    const dataStart = offset + headerLen

    if (type === TYPE_IMAGE) {
      // Bei segmentierten Karten ist headerLen = 28 (mit segments-Feld davor),
      // bei alten Karten 24 ohne segments-Feld.
      let segments, top, left, height, width
      if (headerLen >= 28) {
        segments = dv.getUint32(offset + 8, true)
        top = dv.getUint32(offset + 12, true)
        left = dv.getUint32(offset + 16, true)
        height = dv.getUint32(offset + 20, true)
        width = dv.getUint32(offset + 24, true)
      } else {
        segments = 0
        top = dv.getUint32(offset + 8, true)
        left = dv.getUint32(offset + 12, true)
        height = dv.getUint32(offset + 16, true)
        width = dv.getUint32(offset + 20, true)
      }
      const pixels = new Uint8Array(buffer, dataStart, dataLen)
      result.image = { segments, top, left, height, width, pixels }
    } else if (type === TYPE_CHARGER) {
      result.charger = {
        x: dv.getInt32(dataStart, true),
        y: dv.getInt32(dataStart + 4, true),
      }
    } else if (type === TYPE_ROBOT) {
      result.robot = {
        x: dv.getInt32(dataStart, true),
        y: dv.getInt32(dataStart + 4, true),
      }
    } else if (type === TYPE_PATH) {
      // Header (bei headerLen 20): count(u32), size(u32), angle(u32), width(u32).
      const pointCount = headerLen >= 12 ? dv.getUint32(offset + 8, true) : 0
      const points = []
      let p = dataStart
      const pEnd = dataStart + dataLen
      while (p + 4 <= pEnd && (pointCount === 0 || points.length < pointCount)) {
        points.push({
          x: dv.getUint16(p, true),
          y: dv.getUint16(p + 2, true),
        })
        p += 4
      }
      result.path = points
    }

    offset = dataStart + dataLen
  }
  return result
}

// Stabile Farbe für Segment-ID — gleicher Seed → gleiche Farbe pro Raum.
export function segmentColor(segmentId) {
  const palette = [
    '#4FC3F7', '#81C784', '#FFB74D', '#BA68C8',
    '#F06292', '#FFD54F', '#4DB6AC', '#9575CD',
    '#7986CB', '#A1887F', '#90A4AE', '#DCE775',
  ]
  return palette[segmentId % palette.length]
}

// Roborock-Pixelformat (verifiziert per Histogramm auf S7):
//   low  3 Bit (pixel & 0x07)  = Typ:   0 = außerhalb, 1 = Wand/Hindernis, 7 = Floor
//   high 5 Bit (pixel >> 3)    = Segment-ID (0 = unsegmentiert)
//   Spezialfall 0xFF (legacy)  = freier Floor ohne Segment.
export function pixelToRgba(pixel, segmentColors) {
  if (pixel === 0x00) return [0, 0, 0, 0]
  if (pixel === 0xFF) return [220, 220, 220, 255]

  const type = pixel & 0x07
  const seg = pixel >> 3

  if (type === 1) {
    // Wand / Hindernis — klar sichtbar in Schwarz.
    return [20, 20, 20, 255]
  }
  if (type === 7) {
    // Floor — Segmentfarbe falls zugeordnet, sonst hellgrau.
    if (seg > 0) {
      const c = segmentColors[seg] || segmentColor(seg)
      const r = parseInt(c.slice(1, 3), 16)
      const g = parseInt(c.slice(3, 5), 16)
      const b = parseInt(c.slice(5, 7), 16)
      return [r, g, b, 220]
    }
    return [220, 220, 220, 255]
  }
  // sonstige Typen (5, 6, ...) — schwach grau, damit Karte vollständig wirkt.
  return [120, 120, 120, 160]
}
